import { withStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'

const CustomCheckbox = withStyles({
  root: {}
})(Checkbox)

export const DenseCustomCheckbox = withStyles({
  root: {
    padding: 0
  }
})(CustomCheckbox)

export default CustomCheckbox
